import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { extractDomainFromUrl, faviconUrl } from "@/utils/url";
import { memo } from "react";
import type { StepSource } from "./types";

const MAX_STEP_FAVICONS = 10;

export const SourcesFaviconRow = memo(
  ({ sources }: { sources: readonly StepSource[] }) => {
    if (sources.length === 0) return null;

    return (
      <div className="mt-1.5 flex items-center gap-1">
        {sources.slice(0, MAX_STEP_FAVICONS).map((source, i) => {
          const domain = source.url
            ? extractDomainFromUrl(source.url)
            : source.title;
          const favicon = (
            <img
              src={faviconUrl(domain)}
              alt=""
              referrerPolicy="no-referrer"
              className="rounded-full size-5"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          );
          return (
            <Tooltip key={i}>
              <TooltipTrigger asChild>
                {source.url ? (
                  <a
                    href={source.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {favicon}
                  </a>
                ) : (
                  <span>{favicon}</span>
                )}
              </TooltipTrigger>
              <TooltipContent>{domain}</TooltipContent>
            </Tooltip>
          );
        })}
        {sources.length > MAX_STEP_FAVICONS && (
          <span className="ml-0.5 text-[10px] text-muted-foreground/60">
            +{sources.length - MAX_STEP_FAVICONS}
          </span>
        )}
      </div>
    );
  },
);
SourcesFaviconRow.displayName = "SourcesFaviconRow";
